import { render, staticRenderFns } from "./BannerCriteria.vue?vue&type=template&id=ed92e51e&scoped=true&"
import script from "./BannerCriteria.vue?vue&type=script&lang=js&"
export * from "./BannerCriteria.vue?vue&type=script&lang=js&"
import style0 from "./BannerCriteria.vue?vue&type=style&index=0&id=ed92e51e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed92e51e",
  null
  
)

export default component.exports